import * as React from 'react';
import { useSelector } from 'react-redux';

import { PParams } from 'shared/map-search/containers/Adfox/components/AdfoxBanner/types';
import { selectJsonQuery } from 'shared/map-search/selectors/results';
import { getAdfoxPuidParams } from 'shared/map-search/utils/getAdfoxPuidParams';

import type { AdfoxContextData } from '../types';

type Params = AdfoxContextData['params'];

export const PR_RANDOM = getRandomId();

export function getRandomId(): string {
  return String(Math.floor(Math.random() * 4294967295) + 1);
}

export function useAdfoxParams(pParams: PParams): Params {
  const jsonQuery = useSelector(selectJsonQuery);

  return React.useMemo<Params>(
    () => ({
      pr: PR_RANDOM,
      ...getAdfoxPuidParams(jsonQuery),
      ...pParams,
    }),
    [jsonQuery, pParams],
  );
}
